import {Dataset} from "@rezonence/core";

export const freeWallEditorDatasets = [
  Dataset.Freewall,
  Dataset.Microsites,
  Dataset.Meta,
  Dataset.Css,
  Dataset.CustomCode
];
